import { gql } from "@apollo/client";

const GET_COMPANION_SESSION_LIVEKIT_TOKEN = gql`
  mutation getCompanionSessionLiveKitToken(
    $companionSessionUuid: String!
  ) {
    getCompanionSessionLiveKitToken(
      companionSessionUuid: $companionSessionUuid
    ) {
      ok
      livekitUrl
      token
    }
  }
`;

export default GET_COMPANION_SESSION_LIVEKIT_TOKEN;
